<template>
    <div class="warp">
        <van-nav-bar
                safe-area-inset-top
                fixed
                left-arrow
                @click-left="$router.back()"
                placeholder
                :title="$t('lang.实名认证')"
        >
        </van-nav-bar>

        <div class="cont">
            <div class="card" v-show="isShow">
                <div class="user">
                    <img src="@/assets/img/user.png" alt="">
                    <span v-if="status == 0">{{ $t('lang.审核中') }}</span>
                    <span v-else>{{ $t('lang.实名认证成功') }}</span>
                </div>
                <div class="line"></div>
                <div class="bottom">
                    <div class="item">
                        <span>{{ $t('lang.姓名') }}</span>
                        <span>{{ userInfo.name }}</span>
                    </div>
                    <div class="item">
                        <span>{{ $t('lang.身份证号') }}</span>
                        <span>{{ userInfo.idCard }}</span>
                    </div>
                </div>
            </div>

            <van-button
                    v-if="status == 0 && isShow"
                    class="btn"
                    block
                    color="linear-gradient(0deg, rgb(173, 134, 103) 0%, rgb(244, 228, 215) 100%)"
                    @click="toReal"
            >
                {{$t('lang.重新上传')}}
            </van-button>
        </div>
    </div>
</template>

<script>
import Fetch from '@/utils/fetch';

export default {
    name: "realNameStatus",
    data(){
      return {
          userInfo:{},
          status: 0,
          isShow: false
      }
    },
    created() {
        this.$parent.footer('realNameStatus', false)
        this.start();
    },
    methods:{
        toReal(){
          this.$router.push('realName')
        },
        start() {
            Fetch('/user/info').then((r) => {
                this.userInfo = r.data;
                if(r.data.realStatus == 0 && r.data.submitStatus == 1){
                    this.status = 0
                }else if(r.data.realStatus == 1 ){
                    this.status = 1
                }
                this.isShow = true
            });
        },
    }
}
</script>

<style scoped lang="less">
.btn{
  margin-top: 20px;
}
.bottom {
  padding: 0 12px;
  margin-bottom: 20px;
  .item {
    display: flex;
    justify-content: space-between;
    margin-top: 1.25rem;
    font-size: .78125rem;
    align-items: center;
  }
}

.line {
  width: 100%;
  height: 0.03125rem;
  background: #F1EFEE;
  margin: 0 auto;
  margin-top: 1.40625rem;
}

.user {
  width: 100%;
  margin: 0 auto;
  margin-top: 1.40625rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  img {
    width: 53px;
    height: 53px;
  }

  span {
    font-size: .78125rem;
    margin-top: 0.625rem;
    display: inline-block;
  }
}

.card {
  width: 100%;
  background: #241E1F;
  border: 0.0625rem solid #C8B5A1;
  border-radius: 0.40625rem;
  margin: 0 auto;
  margin-top: 0.875rem;
}

.cont {
  padding: 12px;
  color: #d4d3d3;
}

.warp {
  width: 100%;
  height: 100vh;
  background: url(../../assets/img/home-bg.jpg) no-repeat;
  background-size: 100% 100%;
}

/deep/ .van-nav-bar {
  color: rgb(239, 216, 196);
  background-color: rgb(35, 29, 29);
}

/deep/ .van-nav-bar__title {
  color: rgb(239, 216, 196);
}

/deep/ .van-nav-bar .van-icon {
  color: rgb(239, 216, 196);
}
</style>
